<div
  class="alerts-wrapper cg-hide-for-print"
  [class.hide-bg]="alerts.length === 0"
  [class.tasks-alerts-enabled]="isTasksAlertsEnabled"
  *ngIf="alerts.length > 0 || shouldPreventPageJump"
>
  <div class="alerts-inner">
    <div>
      <ng-leaf-icon-next
        *ngIf="alerts.length > 0"
        name="warning"
        category="system"
        weight="fill"
        size="30"
        class="alert-icon cg-color-warn"
      ></ng-leaf-icon-next>
    </div>
    <div class="alert-text" *ngIf="alerts">
      <div
        *ngFor="let alert of alerts"
        data-test-id="alert-body"
        (click)="alertClick($event)"
        [innerHtml]="alert.body"
        class="alert-body"
      ></div>
    </div>
  </div>
</div>
